import Backbone from 'backbone/backbone'
import _ from 'underscore/underscore'

import './Langs.css'
import template from './Langs.jinja'

var Langs = Backbone.View.extend({
    el: '.Langs',

    SHIFT: 15,

    initialize () {
        app.vent.on('langs.activate', this.activate)

        this.$links = this.$('.Langs-link')
    },

    activate(options) {

    },

    deactivate(options) {

    }
})

export default Langs


// WEBPACK FOOTER //
// ./assets/app/front/components/Langs/Langs.js